<template>
  <center v-if="item && item.date">
    {{ display }}
  </center>
</template>
<script>
import { format, isValid, parse } from "date-fns";
import { dateTimeComputed } from "@/default/utils/computed";

export default {
  name: "order-status-route-appt",
  props: {
    item: Object,
    options: Object,
  },
  computed: {
    ...dateTimeComputed,
    formatTime() {
      const timeDate = parse(this.item?.time, "HH:mm", new Date());
      if (!isValid(timeDate)) return;
      return format(timeDate, this.timeFormat);
    },
    display() {
      const parts = [];
      const { date, time } = this.item || {};
      if (date) {
        parts.push(this.$options.filters.usFormat(date, { year: false }));
        if (time) parts.push(this.formatTime);
      }
      return parts.join(" ");
    },
  },
};
</script>
